import React, { Fragment, memo } from 'react'
import PropTypes from 'prop-types'

import { FormControl, FormGroup, FormLabel } from '../../../../../../../components'

import { COUNTRY } from '../../../../../../../utils/constants'

const MemberLoads = (props) => {
  const { isDuplicate, label, errors, load, uplift, country, onChange, onValidateField } = props

  const handleChange = (e) => {
    onValidateField(e)
    onChange(e)
  }

  return (
    <Fragment>
      <FormGroup>
        <FormLabel htmlFor={`${label}.load`}>
          Download ({country === COUNTRY.USA ? 'ASD' : 'LSD'})
        </FormLabel>
        <FormControl
          name={`${label}.load`}
          addonAfter="lbs"
          value={load}
          onChange={handleChange}
          error={errors[`${label}.load`]}
          disabled={isDuplicate}
          data-ga4={`${label}_loads_load:${load}`}
          data-testid={`${label}.load`}
        />
      </FormGroup>

      <FormGroup>
        <FormLabel htmlFor={`${label}.uplift`}>
          Uplift ({country === COUNTRY.USA ? 'ASD' : 'LSD'})
        </FormLabel>
        <FormControl
          name={`${label}.uplift`}
          addonAfter="lbs"
          value={uplift}
          onChange={handleChange}
          error={errors[`${label}.uplift`]}
          disabled={isDuplicate}
          data-ga4={`${label}_loads_uplift:${uplift}`}
          data-testid={`${label}.uplift`}
        />
      </FormGroup>
    </Fragment>
  )
}

MemberLoads.propTypes = {
  isDuplicate: PropTypes.bool,
  label: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  load: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  uplift: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  onValidateField: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
}

MemberLoads.defaultProps = {
  isDuplicate: false,
}

export default memo(MemberLoads)
